import { render, staticRenderFns } from "./PollResultsAverage.vue?vue&type=template&id=23c07a36&scoped=true"
import script from "./PollResultsAverage.vue?vue&type=script&lang=js"
export * from "./PollResultsAverage.vue?vue&type=script&lang=js"
import style0 from "./PollResultsAverage.vue?vue&type=style&index=0&id=23c07a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c07a36",
  null
  
)

export default component.exports